import { cloneObject } from '../../../../utils';
import { getFields } from '../../../../utils/defaultFields';

const fields = [
    'birth',
    'civilState',
    'cpf',
    'dn',
    'enrollmentSequence',
    'fullName',
    'functionalEnrollment',
    'gender',
    'kinshipDegree',
    'motherName',
    'pis',
    'socialName',
    'sus',
    'weddingDate',
    'stateService',
    'countyService',
    'congenerName',
];

const schema = {
    ...cloneObject(getFields(fields)),
    countyService: {
        ...cloneObject(getFields(['countyService'])).countyService,
        required: false,
    },
};

schema.documents = [];
schema.fullName.requiredMessage = 'Adicione o nome e sobrenome da pessoa dependente';
schema.motherName.requiredMessage = 'Digite o nome da mãe da pessoa dependente';
schema.functionalEnrollment.disabled = true;
schema.functionalEnrollment.help = 'Documento que comprova o vínculo da pessoa dependente com a empresa.';

export default schema;
